import { useCallback } from 'react';
import { useSetRecoilState } from 'recoil';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';

import { dashboardProfilePopupOpen } from '../../../state/atoms/dashboardProfilePopupOpen';

export const CloseButton = () => {
  const setModalOpen = useSetRecoilState(dashboardProfilePopupOpen);

  const handleClose = useCallback(() => {
    setModalOpen(false);
  }, [setModalOpen]);

  return (
    <IconButton
      aria-label='close'
      onClick={handleClose}
      sx={
        {
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }
      }
    >
      <CloseIcon />
    </IconButton>
  );
};
